export enum actionTypes {
    SET_FORM_DATA = 'CHANGE_FORM:FORM_DATA:SET',
    TOGGLE_LOADING = 'CHANGE_FORM:IS_LOADING:TOGGLE',
    SET_HIDDEN_BY_RULES_FIELDS = 'CHANGE_FORM:HIDDEN_BY_RULES_FIELDS:SET',
    ADD_HIDDEN_FIELD = 'CHANGE_FORM:HIDDEN_FIELD:ADD',
    REMOVE_HIDDEN_FIELD = 'CHANGE_FORM:HIDDEN_FIELD:REMOVE',
    SET_FORM_INTERNAL_ERROR = 'CHANGE_FORM:FORM_INTERNAL_ERROR:SET',
    SET_LIMITS_SETTINGS = 'CHANGE_FORM:LIMITS_SETTINGS:SET',
    SET_LIMITS_CURRENCY = 'CHANGE_FORM:LIMITS_CURRENCY:SET',
    UPDATE_IMS_VALUES = 'CHANGE_FORM:IMS_VALUES:UPDATE'
}
